import { put, takeLatest, takeEvery } from "@redux-saga/core/effects";
import AxiosCustom from "../../../common/components/apiConfig";
import {
  handleNotificationAlertCatch,
  handleNotificationAlertTrySelect,
  handleNotificationAlertTryUpdate,
} from "../../../common/method/handleNotificationAlert";

export const actionTypes = {
  selectPortfolioKey: "[selectPortfolioKey] Action",
  selectPortfolioKeyLoad: "[selectPortfolioKeyLoad] Action",
  selectPortfolioKeyAsync: "[selectPortfolioKeyAsync] Action",
};

const initialState = {
  data: [],
  loading: false,
};

export const select_portfolio_key_reducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case actionTypes.selectPortfolioKey:
      return {
        ...state,
        data: payload?.data?.results ? payload?.data?.results : [],
      };
    case actionTypes.selectPortfolioKey:
      return {
        ...state,
        loading: payload,
      };

    default:
      return state;
  }
};

function* handleWorker({ payload }) {
  yield put({ type: actionTypes.selectPortfolioKeyLoad, payload: true });
  let config = {
    url: "select_request",
  };

  let data = {
    table: "portfolio",
    method_type: "select_key_statistics",
    data: payload.data?payload.data:{},
  };

  try {
    let res = yield AxiosCustom(config, data);
    yield put({
      type: actionTypes.selectPortfolioKey,
      payload: res.data.response,
    });
  } catch {
    handleNotificationAlertCatch();
    // yield put({ type: actionTypes.creaditSelectLoad, payload: false });
  } finally {
    yield put({ type: actionTypes.selectPortfolioKeyLoad, payload: false });
  }
}

export function* selectPortfolioKey() {
  yield takeEvery(actionTypes.selectPortfolioKeyAsync, handleWorker);
}
